import { Button } from "components";
import "./style.scss";

const MobileViewButton = ({
    handleClickContained,
    handleClickOutlined,
    bordered,
    relative,
    contained,
    outlined,
    containedTitle,
    outlinedTitle,
    customContainer,
    disableContainedMobile,
    disableOutlinedMobile,
    loadingOutlineMobile,
    customClassContained,
    customClassOutlined,
    ...props
}: any) => {
    const TwoButton = (
        <div
            className={`create-shelf-btn-container ${
                bordered ? "bordered" : ""
            } ${relative ? "relative" : ""} ${customContainer}`}
        >
            {contained && (
                <Button
                    btnText={containedTitle}
                    variant="light"
                    className={` solid is-green create-shelf-btn ${customClassContained}`}
                    handleClick={handleClickContained}
                    {...props}
                    disabled={disableContainedMobile}
                />
            )}
            {outlined && (
                <Button
                    btnText={outlinedTitle}
                    variant={` is-green bordered ${customClassOutlined}`}
                    className={` is-green ${customClassOutlined}`}
                    handleClick={() => handleClickOutlined()}
                    {...props}
                    disabled={disableOutlinedMobile}
                    loading={loadingOutlineMobile}
                />
            )}
        </div>
    );

    return <>{TwoButton}</>;
};
export default MobileViewButton;
